export default "__VITE_ASSET__B6jujbP$__"